import { PropsWithChildren } from 'react';

import { useAgentStatusDisplay } from '@/hooks/use-agent-status-display';
import { useIsInternalUser } from '@/hooks/use-is-internal-user';

import { AgentStatusSplash } from './agent-status-splash';

export const AgentStatusContentGate = ({ children }: PropsWithChildren) => {
  const { splashVariant } = useAgentStatusDisplay();
  const isInternalUser = useIsInternalUser();

  if (splashVariant && !isInternalUser) {
    return <AgentStatusSplash variant={splashVariant} />;
  }

  return <>{children}</>;
};
